<template>
  <section class="md:gap-x-6 xl:gap-x-8 border-app-green">
    <h2 v-if="title" class="mb-6 text-2xl font-bold leading-none uppercase">{{ title }}</h2>
    <div class="grid grid-cols-1 gap-4" :class="gridColsClass">
      <article v-for="(cta, idx) in ctas" :key="idx" class="group relative flex w-full">
        <MoleculeCallToAction :cta="cta" />
      </article>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  item: string
  title: string
  ctas: { title?: string; ctas: any[] }
}

const props = defineProps<Props>()

const gridColsClass = computed(() => {
  const count = props.ctas.length ?? 0
  if (count >= 4) {
    return 'md:grid-cols-2 xl:grid-cols-4'
  } else if (count == 3) {
    return 'md:grid-cols-2 xl:grid-cols-3'
  } else if (count == 2) {
    return 'md:grid-cols-2 xl:grid-cols-2'
  }
  return 'md:grid-cols-1'
})
</script>
